import * as yup from 'yup';
import config from '@config/index';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import { CHANGE_TEMPLATE_DESCRIPTION_MAX_LENGTH } from '../constants';
import type { TChangeTemplateAssessmentFormValues, TChangeTemplateFormValues } from '../types';

export const DEFAULT_CHANGE_TEMPLATE_FORM: TChangeTemplateFormValues = { title: '', description: '' };

export const changeTemplateTitleSchema = yup
  .string()
  .trim()
  .required(`Enter a ${TERMINOLOGY.changeTemplate.lower} title.`)
  .max(config.ITEM_NAME_MAX_LENGTH);

export const changeTemplateFormSchema: yup.ObjectSchema<TChangeTemplateFormValues> = yup.object({
  title: changeTemplateTitleSchema,
  description: yup.string().defined().max(CHANGE_TEMPLATE_DESCRIPTION_MAX_LENGTH),
});

export const DEFAULT_CHANGE_TEMPLATE_ASSESSMENT_FORM: TChangeTemplateAssessmentFormValues = {
  title: '',
  required: true,
};

export const changeTemplateAssessmentFormSchema: yup.ObjectSchema<TChangeTemplateAssessmentFormValues> = yup.object({
  title: yup.string().trim().required('Enter an assessment title.').max(config.ITEM_NAME_MAX_LENGTH),
  required: yup.boolean().required(),
});
